const { defineTheme, copy, value } = require('@dbk/com.db.dbk.theme-utils');

const theme = require('@dbk/com.db.dbk.ui-theme');

module.exports = defineTheme('popover', {
  /**
   * @label Background color
   * @editor color
   */
  backgroundColor: value('color', '#fff'),
  /**
   * @label Secondary background color
   * @editor color
   */
  secondaryBackgroundColor: value('color', '#edf1f7'),
  /**
   * @label Tertiary background color
   * @editor color
   */
  tertiaryBackgroundColor: value('color', '#fff'),
  /**
   * @label Background color on alert state
   * @editor color
   */
  alertBackgroundColor: value('color', '#fff'),
  /**
   * @label Border color on alert state
   * @editor color
   */
  borderColorAlert: value('color', '#FF3838'),
  /**
   * @label Border size on alert state on arrow side
   * @editor size
   */
  arrowSideBorderSizeAlert: value('size', 2, 'px'),
  /**
   * @label Border color on warning state
   * @editor color
   */
  borderColorWarning: copy(theme.palettePrimaryWarning),
  /**
   * @label Background color
   * @editor color
   */
  borderColor: 'transparent',
  /**
   * @label Arrow border color
   * @editor color
   */
  arrowBorderColor: 'rgba(0,0,0,.1)',
  /**
   * @label Close button background color
   * @editor color
   */
  closeButtonBackground: copy(theme.palettePrimaryStrokeLine),
  /**
   * @label Close button inverse background color
   * @editor color
   */
  closeButtonInverseBackground: copy(theme.palettePrimaryStrokeLine),
  /**
   * @label Close button inverse active color
   */
  closeButtonActiveInverseColor: copy(theme.palettePrimarySelected),
  /**
   * @label Close button active color
   */
  closeButtonActiveColor: copy(theme.palettePrimarySelected),
  /**
   * @label Close button inverse hover color
   * @editor color
   */
  closeButtonHoverInverseColor: copy(theme.palettePrimaryHover),
  /**
   * @label Close button hover color
   * @editor color
   */
  closeButtonHoverColor: copy(theme.palettePrimaryHover),
  /**
   * @label Margin
   * @editor margin
   */
  margin: value('size', 12, 'px'),
  /**
   * @label Text color
   * @editor color
   */
  textColor: value('color', '#2B3A3E'),
  /**
   * @label Secondary text color
   * @editor color
   */
  secondaryTextColor: value('color', '#535b61'),
  /**
   * @label Tertiary text color
   * @editor color
   */
  tertiaryTextColor: value('color', '#535b61'),
  /**
   * @label Border radius
   * @editor radius
   */
  borderRadius: value('size', 2, 'px'),
  /**
   * @label Border radius
   * @editor radius
   */
  borderRadiusAlert: value('size', 0, 'px'),
  /**
   * @label Boxshadow size
   * @editor width
   */
  boxShadowHorizontal: value('size', 0, 'px'),
  /**
   * @label Boxshadow size
   * @editor width
   */
  boxShadowVertical: value('size', 0, 'px'),
  /**
   * @label Boxshadow size
   * @editor width
   */
  boxShadowBlur: value('size', 4, 'px'),
  /**
   * @label Boxshadow size
   * @editor width
   */
  boxShadowSpread: value('size', 1, 'px'),
  /**
   * @label Boxshadow color
   * @editor color
   */
  boxShadowColor: 'rgba(0, 0, 0, 0.1)',
  /**
   * @label Popover animation duration
   * @editor duration
   */
  motionDuration: copy(theme.motionQuickDuration),
  /**
   * @label Padding extra small
   * @editor padding
   */
  contentPadding: value('size', 15, 'px'),
  /**
   * @label Popover triangle width
   * @editor width
   */
  triangleWidth: value('size', 16, 'px'),
  /**
   * @label Popover triangle height
   * @editor height
   */
  triangleHeight: value('size', 8, 'px'),
  /**
   * @label Background color
   * @editor color
   */
  inverseBackground: value('color', '#12213C'),
  /**
   * @label Font inverse size
   * @editor fontSize
   */
  inverseFontSize: value('size', 12, 'px'),
  /**
   * @label Font invers color
   * @editor color
   */
  inverseTextColor: '#ffffff',
  /**
   * @label Border inverse color
   * @editor color
   */
  inverseBorderColor: value('color', 'none'),
  /**
   * @label Popover horizontal offset
   * @editor offset
   */
  popoverHorizontalOffset: value('size', 2, 'px'),
  /**
   * @label Popover vertical offset
   * @editor offset
   */
  popoverVerticalOffset: value('size', 4, 'px'),
  /**
   * @label Close button body padding
   * @editor padding
   */
  closeButtonBodyPadding: value('size', 30, 'px'),
  /**
   * @label Close button width
   * @editor width
   */
  closeButtonHeight: value('size', 22, 'px'),
  /**
   * @label Close button height
   * @editor height
   */
  closeButtonWidth: value('size', 22, 'px'),
  /**
   * @label Close button vertical padding
   * @editor padding
   */
  closeButtonTop: value('size', 15, 'px'),
  /**
   * @label Close button horizontal padding
   * @editor padding
   */
  closeButtonRight: value('size', 5, 'px'),
});
